import { render, staticRenderFns } from "./WorkstationConfig.vue?vue&type=template&id=2d7803ae"
import script from "./WorkstationConfig.vue?vue&type=script&lang=js"
export * from "./WorkstationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports